import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { combineReducers, Store } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import storage from "redux-persist/es/storage"; // default: localStorage if web, AsyncStorage if react-native
import { App } from "./components/app";
import { ApplicationState, reducers } from "./store/";
import reportWebVitals from "./utils/reportWebVitals";
import { connectRouter } from "connected-react-router";
import configureStore from "./store/configureStore";
import { Router } from "react-router-dom";
import history from "./utils/history";
import ShopifyApolloProvider from "./components/app/ShopifyApolloProvider/ShopifyApolloProvider";

const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store: Store<ApplicationState> = configureStore(
  history,
  persistedReducer
);
export const persistor = persistStore(store);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <ShopifyApolloProvider>
            <App />
          </ShopifyApolloProvider>
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
